import React from 'react';
import { CollectionsRail } from '@sg/garnish';

import { useNavigateToMenuCollection } from '@order/hooks';
import { useLocalizationContext } from '@order/Localization';

import { useMenuCollections } from './MenuCollectionsRail.hooks';

// ────────────────────────────────────────────────────────────────────────────────

export const MenuCollectionsRail = (props: MenuCollectionsRailProps) => {
  const { t } = useLocalizationContext();

  const {
    menuCollectionId,
    isLoading = false,
    headerText = t('menu-collection.more-collections'),
    excludedCollectionId,
    testID,
  } = props;

  const navigateToMenuCollection = useNavigateToMenuCollection();
  const { formattedMenuCollections, isFetching: isFetchingMenuCollections } =
    useMenuCollections(menuCollectionId, excludedCollectionId);
  const isFetching = isLoading || isFetchingMenuCollections;

  // ─────────────────────────────────────────────────────────────────

  return (
    <CollectionsRail
      isLoading={isFetching}
      collections={formattedMenuCollections}
      onPress={navigateToMenuCollection}
      headerText={headerText}
      headerVariation="display"
      withoutHeaderBorder
      testID={testID}
    />
  );
};

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type MenuCollectionsRailProps = {
  readonly menuCollectionId: string;
  readonly excludedCollectionId?: string;
  readonly isLoading?: boolean;
  readonly headerText?: string;
  readonly testID?: string;
};
